import Damage from "../../../../model/crew/Damage";
import BigNum from "../../../../model/math/BigNum";
import Values from "../../../../model/value/Values";
import { Settings } from "../../../../Settings";
import NumberFormatter from "../../../../util/NumberFormatter";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class BaseDamagePerSecondView extends View {
    /**
     * @param {string} parentId
     * @param {Damage} damage
     * @param {Values} values
     */
    constructor(parentId, damage, values) {
        super(parentId, parentId + '_base_ore');

        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;
        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedBaseDamagePerTurn = new BigNum(0);
        /**
         * @type {string}
         */
        this.basePickDamageString = null;

        /**
         * @constant
         * @type {BigNum}
         */
        this.workingNum = new BigNum(0);

        /**
         * We don't need to convert the turnsPerSecond number into a BigNum every single turn.
         * @constant
         * @type {BigNum}
         */
        this.turnsPerSecond = new BigNum(Settings.time.turnsPerSecond);

        /**
         * @type {HTMLElement}
         */
        this.baseAdditiveBody = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // base
        ////////////////////////////////////

        const baseAdditiveDiv = Page.createElement('div', parentElement, null, 'mine-damage-panel-main-section');
        const baseAdditiveHeader = Page.createElement('div', baseAdditiveDiv, null, 'mine-damage-panel-section-header');
        baseAdditiveHeader.innerHTML = 'Base';

        this.baseAdditiveBody = Page.createElement('div', baseAdditiveDiv, null, 'mine-damage-panel-section-body');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateViewContents() {

        const baseDamagePerTurn = this.damage.baseDamagePerTurn;

        if (!this.basePickDamageString || !baseDamagePerTurn.equals(this.displayedBaseDamagePerTurn)) {
            this.displayedBaseDamagePerTurn.copy(baseDamagePerTurn);

            this.workingNum.copy(baseDamagePerTurn);
            this.workingNum.mul(this.turnsPerSecond); // convert from perTurn to perSecond
            this.basePickDamageString = NumberFormatter.formatBigNum(this.workingNum) + '/s';

            this.baseAdditiveBody.innerHTML = this.basePickDamageString;
        }

        super.updateViewContents();
    }

}